// import { defineFormKitConfig } from '@formkit/vue'
import { createMultiStepPlugin } from '@formkit/addons'
import { es } from '@formkit/i18n'
// import { genesisIcons } from "@formkit/icons"
import { rootClasses } from './formkit.theme.mjs'

export default {
  plugins: [createMultiStepPlugin()],
  locales: { es },
  locale: 'es',
  // icons: { ...genesisIcons },
  config: {
    rootClasses
  }
}